<template>
  <transition name="fade">
    <!-- Dashboard Header -->
    <div id="dashboard-header">
      <div
        :class="{'flex-column': flexColumn}"
        class="header-wrapper justify-content-md-between flex-md-row"
      >
        <div
          :class="{'align-self-start': flexColumn, 'mb-2': flexColumn}"
          class="d-flex align-items-center mb-md-0 align-self-md-center"
        >
          <!-- Title -->
          <h1 class="m-0" @click="openDialog">
            {{ title }}
            <!--            <img-->
            <!--              svg-inline-->
            <!--              src="@/assets/img/icons/check-mark.svg"-->
            <!--              alt=""-->
            <!--              class="completed-check"-->
            <!--            >-->
          </h1>
          <!-- /Title -->

          <!-- Switch -->
          <template v-if="stepStatusSwitchVisible">
            <step-status-switch :step-name="completedStepName" />
          </template>
          <!-- /Switch -->

          <template v-if="openPageBtnVisible">
            <open-business-plan
              v-if="statusOfCompleted"
              class="ml-3"
              :section-id="businessPlanSectionId"
            />
          </template>
        </div>
        <!-- Buttons wrapper -->
        <div
          class="d-flex align-items-center align-self-end align-self-md-center"
          :class="{
            'intro-active':
              $store.state.user.tutorial.guideAndExampleCompleted === false &&
              1 === 2
          }"
        >
          <p v-if="showTemplateComingSoon" class="template-coming-soon font-tragic-marker ma-0 mr-4 text-ai d-md-none d-xl-block">
            {{ $t('templateComingSoon') }}
          </p>

          <ai-template-blinking-animation
            v-if="getLoaders.aiTemplate || getLoaders.aiBuddy"
            class="mr-4 d-md-none d-xl-block"
          />

          <slot name="actions" />

          <ai-buddy-button
            v-if="aiBuddyButtonVisible"
            :disabled="statusOfCompleted || getLoaders.aiBuddy || getLoaders.aiTemplate"
            responsive
            :animation="getAiBuddyButtonAnimationsShow.defaultButton"
            @click="onClickAiBuddyButton"
          />

          <info-button
            v-if="infoButtonVisible"
            responsive
            :active="guideVisible || guideVisibleFirstTime"
            class="ml-2"
            @click="$emit('open-info')"
          />

          <!-- Quick tour -->
          <!--          <ib-quick-tour-button-->
          <!--            v-if="!hideQuickTourButton"-->
          <!--            :active="quickTourVisible"-->
          <!--            @click="toggleQuickTour"-->
          <!--          />-->
          <!-- /Quick tour -->

          <!-- Guide -->
          <!--          <ib-guide-button-->
          <!--            v-if="!hideGuideButton"-->
          <!--            :active="guideVisible"-->
          <!--            @click="toggleGuide"-->
          <!--          />-->
          <!-- /Guide -->

          <!-- Tutorial Tooltip TODO - Currently disabled in if directive -->
          <tutorial-tooltip
            v-if="$store.state.user.tutorial.guideAndExampleCompleted === false && 1 === 2"
            :title="'Need some help trough every step? Have no fear, Guide and Example are here!'"
            :text="'If you ever feel stuck <strong>Guide and Example can help you trough each step!</strong> Lorem ipsum dolor sit amet, consectetur, adipiscing elit praesent. Lorem ipsum dolor sit amet, consectetur, adipiscing elit praesent. Lorem ipsum dolor sit amet, consectetur.'"
            :tutorial-name="'guideAndExampleCompleted'"
          />
        <!-- /Tutorial Tooltip -->
        </div>
        <!-- /Buttons wrapper -->
      </div>
    </div>
    <!-- /Dashboard Header -->
  </transition>
</template>

<script>
// import IbGuideButton from '@/components/_v2/Button/IbGuideButton'
// import IbQuickTourButton from '@/components/_v2/Button/IbQuickTourButton'
import AiBuddyButton from '@/views/Home/StoryMode/Components/AiBuddyButton.vue'
import AiTemplateBlinkingAnimation from '@/views/Home/StoryMode/Components/AiTemplateBlinkingAnimation.vue'
import InfoButton from '@/views/Home/StoryMode/Components/InfoButton.vue'
import MixinAiBuddyButtonAnimation from '@/mixins/aiBuddyButtonAnimations'
import MixinHeaderScroll from '@/mixins/headerScroll'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import OpenBusinessPlan from '@/views/Home/StoryMode/Components/OpenBusinessPlan.vue'
import StepStatusSwitch from '@/views/Home/StoryMode/Components/StepStatusSwitch.vue'
import TutorialTooltip from '@/views/Home/Components/TutorialTooltip'
import _find from 'lodash/find'
import { mapGetters } from 'vuex'

export default {
  name: 'DashboardHeader',

  components: {
    AiTemplateBlinkingAnimation,
    OpenBusinessPlan,
    InfoButton,
    AiBuddyButton,
    StepStatusSwitch,
    // IbQuickTourButton,
    TutorialTooltip
    // IbGuideButton
  },

  mixins: [
    MixinIdeaRoles,
    MixinHeaderScroll,
    MixinAiBuddyButtonAnimation
  ],

  props: {
    title: {
      default: '',
      type: String
    },
    quickTourVisible: {
      type: Boolean,
      default: false
    },
    guideVisible: {
      default: false,
      type: Boolean
    },
    guideVisibleFirstTime: {
      default: false,
      type: Boolean
    },
    completedStepName: {
      type: String,
      default: ''
    },
    hideQuickTourButton: {
      type: Boolean,
      default: false
    },
    hideGuideButton: {
      type: Boolean,
      default: false
    },
    scrollHeader: {
      type: Boolean,
      default: true
    },
    flexColumn: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters('idea', {
      getStepIsCompleted: 'getStepIsCompleted',
      getBusinessPlanSections: 'getBusinessPlanSections',
      isIdeaFromTemplate: 'isIdeaFromTemplate'
    }),
    ...mapGetters('ui', ['getLoaders']),

    statusOfCompleted () {
      return this.getStepIsCompleted(this.completedStepName)
    },

    aiBuddyButtonVisible () {
      return !['idea-plan', 'business-guide', 'validation-idea-score', 'validation-idea-score-test', 'business-plan'].includes(this.$route.name)
    },

    infoButtonVisible () {
      return !['idea-plan', 'business-guide', 'validation-idea-score-test', 'business-plan'].includes(this.$route.name)
    },

    stepStatusSwitchVisible () {
      return !['idea-plan', 'business-guide', 'validation-idea-score', 'validation-idea-score-test', 'business-plan'].includes(this.$route.name)
    },

    openPageBtnVisible () {
      return !['idea-plan', 'business-guide', 'validation-idea-score', 'validation-idea-score-test', 'business-plan'].includes(this.$route.name)
    },

    showTemplateComingSoon () {
      return this.isIdeaFromTemplate && ![
        'business-guide',
        'business-guide-concept-idea',
        'business-guide-concept-product',
        'business-guide-concept-promotion',
        'business-guide-concept-distribution',
        'business-guide-concept-partners',
        'business-guide-set-up-financing',
        'business-guide-research-market',
        'business-guide-research-customers',
        'business-guide-research-competitors',
        'business-guide-research-swot-analysis',
        'business-guide-research-market-potential',
        'business-guide-set-up-management-team',
        'business-guide-set-up-ownership',
        'business-guide-projections-profit-and-cash-flow',
        'business-guide-set-up-startup-costs',
        'business-guide-set-up-staff-and-payroll',
        'business-guide-projections-revenue-streams',
        'business-guide-projections-direct-costs',
        'business-guide-projections-marketing-budget',
        'business-guide-projections-other-overheads',
        'validation-idea-score',
        'validation-idea-score-test',
        'business-plan',
        'idea-plan'
      ].includes(this.$route.name)
    },

    businessPlanSectionId () {
      const mappedKeys = {
        ideaCompleted: 'Idea',
        productCompleted: 'Product',
        promotionCompleted: 'Promotion',
        distributionCompleted: 'Distribution',
        partnerCompleted: 'Partner',
        marketCompleted: 'Market',
        customersCompleted: 'Customers',
        competitorsCompleted: 'Competitors',
        swotAnalysisCompleted: 'SwotAnalysis',
        marketPotentialCompleted: 'MarketPotential',
        startupCostsCompleted: 'StartupCosts',
        financingCompleted: 'Financing',
        managementTeamCompleted: 'ManagementTeam',
        employeesAndPayrollCompleted: 'StaffAndPayroll',
        ownershipCompleted: 'Ownership',
        revenueStreamsCompleted: 'RevenueStreams',
        directCostsCompleted: 'DirectCosts',
        marketingBudgetCompleted: 'MarketingBudget',
        otherOverheadsCompleted: 'OtherOverheads',
        profitAndCashFlowCompleted: 'ProfitAndCashFlow'
      }

      const section = _find(this.getBusinessPlanSections, ['sectionName', mappedKeys[this.completedStepName]])

      return section ? section.id : null
    }
  },

  methods: {
    openDialog () {
      if (this.statusOfCompleted) {
        if (this.canEdit) this.$emit('open-comp-dialog')

        return true
      }

      return false
    },

    onClickAiBuddyButton () {
      this.$emit('open-ai-buddy-drawer')
      this.hideAiBuddyBuddyAnimation('defaultButton')
    },

    toggleQuickTour () {
      if (this.openDialog()) return

      if (this.guideVisible) {
        this.toggleGuide()
      }

      if (!this.quickTourVisible) {
        document.querySelector('.page-content').scrollTo(0, 0)
      }

      this.$emit('toggle-quick-tour', !this.quickTourVisible)
    },

    toggleGuide () {
      this.$emit('toggle-guide')
      this.$emit('toggle-quick-tour', false)

      // toDo new event for guide button
      this.$gtm.trackEvent({
        event: 'exampleButton'
      })

      if (!this.guideVisible) {
        document.querySelector('.page-content').scrollTo(0, 0)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.template-coming-soon {
  font-size: 18px;
}
</style>
